import { File } from "./File";
import { Event } from "./Event";
import { Participant } from "./Participant";
import { Document } from "./Document";
import { User } from "./User";
import { Matter } from "./Matter";

export const activityTypes = {
  event_created: {
    label: "Event created",
    color: "blue",
  },
  file_created: {
    label: "File created",
    color: "green",
  },
};

export type ActivityType = keyof typeof activityTypes;

interface AcitivityData {
  file?: File["_id"] | File;
  event?: Event["_id"] | Event; // Use string to support legacy events without type
  participant?: Participant["_id"] | Participant;
  document?: Document["_id"] | Document; // For document-related activities
}

export interface Activity {
  _id: string;
  matter: Matter["_id"] | Matter; // The matter to which this activity belongs
  user: User;
  type: ActivityType;
  data?: AcitivityData;

  createdAt: Date;
  updatedAt: Date;
  updatedBy: string;
}
